// extracted by mini-css-extract-plugin
module.exports = {"offerMarkdown":"OfferDetailView_offerMarkdown__W8j0R"};